<template>
    <HeaderPart />

    <MainPage />

  <FooterPart />
</template>

<script>
// @ is an alias to /src
import MainPage from '@/pages/MainPage.vue';
import HeaderPart from '@/components/HeaderPart.vue';
import FooterPart from '@/components/FooterPart.vue';

export default {
  name: 'StartView',
  components: {
    MainPage,
    HeaderPart,
    FooterPart
  }
}
</script>
